import { render, staticRenderFns } from "./ps_information.vue?vue&type=template&id=172f04ae"
import script from "./ps_information.vue?vue&type=script&lang=js"
export * from "./ps_information.vue?vue&type=script&lang=js"
import style0 from "./ps_information.vue?vue&type=style&index=0&id=172f04ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports